export const quizResult = {
    totalQuestions: 30,
    attempted: 30,
    correct: 21,
    incorrect: 9,
    language: "English",
    markPerCorrect: 5,
    negativeMarkPercent: 10,
    answers: [
      // Existing 10 questions...
      {
        question: "Who is the Prime Minister of India?",
        given: "1",
        correct: "A Only",
        status: "Correct"
      },
      {
        question: "Who is the first man landed in the moon?",
        given: "2,1",
        correct: "Buzz Aldrin, Mare Crisium",
        status: "Correct"
      },
      {
        question: "What is ASAP?",
        given: "GRWM",
        correct: "ASAP",
        status: "Wrong"
      },
      {
        question: "What is 12 am?",
        given: "PM",
        correct: "AM, am",
        status: "Wrong"
      },
      {
        question: "Capital of France?",
        given: "Paris",
        correct: "Paris",
        status: "Correct"
      },
      {
        question: "HTML stands for?",
        given: "Hyper Text Markup Language",
        correct: "Hyper Text Markup Language",
        status: "Correct"
      },
      {
        question: "Largest planet in the solar system?",
        given: "Jupiter",
        correct: "Jupiter",
        status: "Correct"
      },
      {
        question: "Fastest land animal?",
        given: "Cheetah",
        correct: "Cheetah",
        status: "Correct"
      },
      {
        question: "Water freezes at?",
        given: "100°C",
        correct: "0°C",
        status: "Wrong"
      },
      {
        question: "2 + 2 * 2 = ?",
        given: "6",
        correct: "6",
        status: "Correct"
      },
  
      // English Questions
      {
        question: "Synonym of 'Happy'?",
        given: "Joyful",
        correct: "Joyful",
        status: "Correct"
      },
      {
        question: "Antonym of 'Cold'?",
        given: "Hot",
        correct: "Hot",
        status: "Correct"
      },
      {
        question: "Fill in the blank: She ____ to school daily.",
        given: "go",
        correct: "goes",
        status: "Wrong"
      },
      {
        question: "Choose the correct spelling:",
        given: "Accommodate",
        correct: "Accommodate",
        status: "Correct"
      },
      {
        question: "Past tense of 'run'?",
        given: "ran",
        correct: "ran",
        status: "Correct"
      },
  
      // Logical Reasoning Questions
      {
        question: "What comes next in the sequence: 2, 4, 8, 16, ?",
        given: "32",
        correct: "32",
        status: "Correct"
      },
      {
        question: "If ALL BALL are WALL, then all WALL are?",
        given: "Not clear",
        correct: "Cannot be determined",
        status: "Correct"
      },
      {
        question: "Which shape is different: Circle, Triangle, Square, Apple?",
        given: "Apple",
        correct: "Apple",
        status: "Correct"
      },
      {
        question: "Find the odd one out: 3, 5, 7, 11, 14",
        given: "14",
        correct: "14",
        status: "Correct"
      },
      {
        question: "If CAT = 24, DOG = ?",
        given: "26",
        correct: "26",
        status: "Correct"
      },
  
      // Maths Questions
      {
        question: "What is 15% of 200?",
        given: "30",
        correct: "30",
        status: "Correct"
      },
      {
        question: "Square root of 144?",
        given: "12",
        correct: "12",
        status: "Correct"
      },
      {
        question: "Solve: (5 + 3) * 2",
        given: "16",
        correct: "16",
        status: "Correct"
      },
      {
        question: "If x = 3, find value of x² + 2x",
        given: "15",
        correct: "15",
        status: "Correct"
      },
      {
        question: "What is the perimeter of a square with side 4 cm?",
        given: "16",
        correct: "16",
        status: "Correct"
      },
      {
        question: "What is 7 * 6?",
        given: "42",
        correct: "42",
        status: "Correct"
      },
      {
        question: "Solve: 100 / (5 * 2)",
        given: "10",
        correct: "10",
        status: "Correct"
      },
      {
        question: "Area of rectangle (length=4, breadth=3)?",
        given: "12",
        correct: "12",
        status: "Correct"
      },
      {
        question: "Convert 0.75 to percentage",
        given: "75%",
        correct: "75%",
        status: "Correct"
      },
      {
        question: "Solve: 9 - 3 + 2",
        given: "8",
        correct: "8",
        status: "Correct"
      }
    ]
  };
  